import MainLayout from "@/components/layout/admin/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";

export default {
    name: "jobDetail",
    components: {
        MainLayout
    },

    data() {
        return {
            job: {
                company_logo: "",
                company_name: "",
                job_title: "",
                region: "",
                town: "",
                adddress: "",
                min_salary: "",
                max_salary: "",
                job_type: "",
                experience: "",
                qualification: "",
                description: "",
                // latitude: "",
                // longitude: "",
                gender: "",
                expired_date: ""
            },

            jobType: [{
                    value: "1",
                    name: "Full-time"
                },
                {
                    value: "2",
                    name: "Part-time"
                },
                {
                    value: "3",
                    name: "Internship"
                },
                {
                    value: "4",
                    name: "Freelance"
                },
                {
                    value: "5",
                    name: "Remote Job"
                }
            ],
            regionArr: RegionJson,
            jobApplyList: {},
            jobApplyListLength: {}
        };
    },

    methods: {
        getJobDetail() {
            axios.get("/job/detail/" + this.$route.params.id)
                .then(response => {
                    this.job = response.data;
                })
                .catch(error => {
                    console.log("Job Detail API Error", error);
                });
        },

        getJobApply() {
            axios.get("admin/job/apply/" + this.$route.params.id)
                .then(response => {
                    this.jobApplyList = response.data;
                    this.jobApplyListLength = this.jobApplyList.length;
                })
                .catch(error => {
                    console.log("Job Apply API Error", error);
                });
        }
    },

    created() {
        this.getJobDetail();
        this.getJobApply();
    }
};
